import { Button, Grid, LinearProgress } from '@material-ui/core';
import Paper from "@material-ui/core/Paper";
import { createStyles, lighten, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@mui/icons-material/Close';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import FormGroup from '@mui/material/FormGroup';
import Typography from '@mui/material/Typography'
import { green } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { pink } from '@mui/material/colors';
import Backdrop from '@mui/material/Backdrop';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { TransitionProps } from '@mui/material/transitions';
import axios from "axios";
import jaLocale from 'date-fns/locale/ja';
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { API_URL, REACT_APP_DOMAIN } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';
import { useRecoilValue, useRecoilState } from 'recoil';
import { createdConstructionNameState } from '../../globalStates/createConstructionName';
import { blackboardInfo, blackboardDataId } from '../../BlackBoardConst';
import { formatDate } from './utils/date';


/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/

const currencies = [
  {
    value: '1',
    label: 'チェック１',
  },
  {
    value: '2',
    label: 'チェック2',
  },
  {
    value: '3',
    label: 'チェック3',
  },
  {
    value: '4',
    label: 'チェック4',
  },
];


const BorderLinearProgress = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten('#0000FF', 0.9),
  },
  bar: {
    backgroundColor: '#0000FF',
  },
})(LinearProgress);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(1),
      color: theme.palette.text.secondary,
      margin: 3,
    },
  }),
);

const InspectionCreat: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay();

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  const [bbImgData, set_BbImgData] = React.useState();
  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [openComplete, setOpenComplete] = React.useState(false);
  const completeHandleClickOpen = () => {
    setOpenComplete(true);
  }
  const completeHandleClose = () => {
    setOpenComplete(false);
  }


  /*ダイアログ処理*/

  const [isShowCheckLists, setIsShowCheckLists] = React.useState(false)

  /*id取得*/
  const { state } = useLocation();
  const Insid = (state as any)?.Insid;
  const conid = (state as any)?.conid;
  /*id取得*/
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  const dealer_info_id = jsonlist.user.dealer_info_id
  const blackboard_data = JSON.parse(localStorage.getItem("constructionData") || '{}');
  const Url = REACT_APP_DOMAIN + "?id=" + jsonlist.user.user_id + "&p=P@ssword12345&com=" + jsonlist.user.company_id + "&con_id=" + conid + "&ins_id=" + Insid + "&dealer_info_id=" + dealer_info_id + "&user_name=" + jsonlist.user.user_name + "&token=" + jsonlist.token.IdToken


  /*ファイルリストAPI*/

  const [fileposts, setFilePosts] = useState<any[]>([])

  const [isLoadingOverlay, setIsLoadingOverlay] = useState<boolean>(false)

  const createdConstructionName: string = useRecoilValue(createdConstructionNameState)

  const reloadDocuments = () => {
    openLoading()
    return axios.post(API_URL.DOCUMENT_LIST,
      {
        "company_id": jsonlist.user.company_id,
        "inspection_info_id": Insid
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const filedata = res.data.data;
        console.log(filedata)
        setFilePosts(filedata)
      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }
  useEffect(() => {
    reloadDocuments()
  }, []);
  /*ファイルリストAPI*/

  const [posts, setPosts] = useState<any[]>([])

  useEffect(() => {
    openLoading()
    axios.post(API_URL.INSPECTION_GET,
      {

        "company_id": jsonlist.user.company_id,
        "dealer_info_id": jsonlist.user.dealer_info_id,
        "construction_id": conid,
        "inspection_info_id": Insid

      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const insdeta = res.data.data;

        let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
        axios.post(API_URL.BLACKBOARD_CREATE,
          {
            "company_id": jsonlist.user.company_id,
            "dealer_info_id": jsonlist.user.dealer_info_id,
            "construction_id": conid,
            "inspection_info_id": "",
            "bbData": {
              "1": createdConstructionName,
              "2": insdeta.inspection_work_type,
              "3": insdeta.inspection_kind,
              "4": insdeta.common_number,
              "5": insdeta.witness[0] ? insdeta.witness[0].name : "",
              "6": insdeta.witness[1] ? insdeta.witness[1].name : "",
              "7": insdeta.remarks ? insdeta.remarks : ""
            }

          },
          { headers: { Authorization: jsonlist.token.IdToken } },
        )
          .then(res => {
            set_BbImgData(res.data.data.fileData)
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            closeLoading()
          })

        if (insdeta.inspection_status === '1') {
          let insIdList = [Insid];
          let checkResult = new Map<string, string>();
          axios.post(API_URL.CHECK_MEETING_ID, {
            "meetingIds": insIdList
          }).then(res => {
            console.log(res.data);
            for (const v of res.data) {
              checkResult.set(
                v.meetingId, v.status
              )
            }
            const insStatus = checkResult.get(insdeta.inspection_info_id)
            if (insStatus === '2') {
              insdeta.inspection_status = insStatus;
              console.log('insdeta.blackboard', insdeta.blackboard)
              axios.post(API_URL.INSPECTION_UPDATE,
                {
                  "company_id": jsonlist.user.company_id,
                  "dealer_info_id": jsonlist.user.dealer_info_id,
                  "construction_id": conid,
                  "inspection_info_id": insdeta.inspection_info_id,
                  "inspection_info_name": insdeta.inspection_info_name,
                  "blackboard": insdeta.blackboard,
                  "inspection_url": insdeta.inspection_url,
                  "inspection_date": insdeta.inspection_date,
                  "inspection_time": insdeta.inspection_time,
                  "inspection_work_type": insdeta.inspection_work_type,
                  "inspection_kind": insdeta.inspection_kind,
                  "common_number": insdeta.common_number,
                  "inspection_status": insdeta.inspection_status,
                  "template": "テンプレート",
                  "checklist_activation": insdeta.checklist_activation,
                  "remarks": insdeta.remarks,
                  "checklist": insdeta.checklist,
                  "witness": insdeta.witness,
                  "actor": insdeta.actor
                },
                { headers: { Authorization: jsonlist.token.IdToken } },
              )
            }
          }
          )
        }
        setPosts(insdeta)
      })
      .catch(error => {
        //let jsonObject = JSON.parse(error);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })
  }, []);

  const actor = (posts as any)?.actor
  const names = []
  for (var key in actor) {
    //console.log(actor[key].name);
    names.push(actor[key].name)
  }

  const inspection_work_type = (posts as any)?.inspection_work_type;
  const inspection_kind = (posts as any)?.inspection_kind;
  const blackboard = (posts as any)?.blackboard;
  const updated_at = (posts as any)?.updated_at;
  const inspection_date = (posts as any)?.inspection_date;
  const inspection_time = (posts as any)?.inspection_time;
  const inspection_status = (posts as any)?.inspection_status;
  const common_number = (posts as any)?.common_number;
  const witness = (posts as any)?.witness;
  const witness_mail_address = (posts as any)?.witness_mail_address;
  const remarks = (posts as any)?.remarks;
  const checkList = (posts as any)?.checklist
  const checkListActivation = (posts as any)?.checklist_activation

  const classes = useStyles();
  const length = 2;
  const length2 = 4;
  const [currency, setCurrency] = React.useState('1');
  const [value, setValue] = React.useState<Date | null>(new Date());
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrency(event.target.value);
  };


  const inspectionDetailBlackBoardInfo = blackboardInfo.map(info => {
    let detailData;
    switch (info.id) {
      case blackboardDataId.constructionName:
        detailData = { ...info, data: blackboard_data.constructionName }
        break;
      case blackboardDataId.constructionType:
        detailData = { ...info, data: inspection_work_type }
        break;
      case blackboardDataId.inspectionKind:
        detailData = { ...info, data: inspection_kind }
        break;
      case blackboardDataId.commonNumber:
        detailData = { ...info, data: common_number };
        break;
      case blackboardDataId.date:
        const formattedDate = formatDate(inspection_date);
        detailData = { ...info, data: formattedDate };
        break;
      case blackboardDataId.company:
        detailData = { ...info, data: blackboard_data.userName }
        break;
      default:
        throw new Error('不明なIDです');
    }


    return detailData;
  })


  /**黒板のデザインを取得 */
  const displayBoardDesign = JSON.parse(localStorage.getItem("blackboardDesign") || '{}');



  const [personName, setPersonName] = React.useState<string[]>([]);
  const handleChangeMultiple = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { options } = event.target;
    const value: string[] = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setPersonName(value);
  };


  const DelCheckSubmit = (e: any) => {
    handleClickOpen();
  }

  const history = useHistory();
  const clickSubmit = (e: any) => {
    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/



    // POST処理　削除
    let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
    openLoading()
    axios.post(API_URL.INSPECTION_DELETE,
      {
        "construction_id": conid,
        "company_id": jsonlist.user.company_id,
        "dealer_info_id": jsonlist.user.company_id,
        "inspection_info_id": Insid
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const del = res.data.data;
        setSuccess(true);
        setLoading(false);
        console.log(res.data)
        console.log('削除成功')
        history.push({ pathname: "/Inspectionlist", state: { conid: conid } });
      })
      .catch(error => {
        setSuccess(true);
        setLoading(false);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

  }

  /*招待URL*/
  const CopyCheckSubmit = (e: any) => {

    // const UrlApp = REACT_APP_DOMAIN + "?id=" + Insid + '@datt.co.jp' + "&p=" + Insid + "_P@ssword1234&com=" + jsonlist.user.company_id + "&dealer_info_id=" + dealer_info_id + "&con_id=" + conid + "&ins_id=" + Insid + "&user_name=" + e.name
    const UrlApp = REACT_APP_DOMAIN + "?id=" + Insid + e.user_name + "&p=" + Insid + "_P@ssword1234&com=" + jsonlist.user.company_id + "&dealer_info_id=" + dealer_info_id + "&con_id=" + conid + "&ins_id=" + Insid + "&user_name=" + e.name

    navigator.clipboard.writeText(UrlApp)


      .then(function () {
        //console.log('コピー');
      }, function (err) {
        //console.error(err);
      });

    toastOpen('コピーしました')
  }


  /*ファイルDL*/
  const DLCheckSubmit = (e: any) => {

    console.log(e)

    openLoading()
    axios.post(API_URL.FILE_ONE_DOWNLOAD,
      {
        "company_id": jsonlist.user.company_id,
        "file_id": e,
        "file_type": "3"
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const DLurl = res.data.data;
        console.log(DLurl)
        window.open(DLurl, '_blank');
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

  }



  /*snack*/
  const [toastOpenFlg, setToastOpen] = React.useState(false)
  const [toastMessage, setToastMessage] = React.useState('')
  const toastOpen = (message: string) => {
    setToastOpen(true);
    setToastMessage(message)
  };

  const toastClose = () => {
    setToastOpen(false);
    setToastMessage('')
  };
  /*snack*/

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={toastClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  /** 資料削除アイコン押下時 **/
  const onClickDeleteDocumentIcon = ({ fileId, fileName }: { fileId: string, fileName: string }) => (e: any) => {
    if (window.confirm(`【${fileName}】 を削除しますか?`)) {
      setIsLoadingOverlay(true)
      axios.post(API_URL.FILE_DELETE,
        {
          "construction_id": conid,
          "company_id": jsonlist.user.company_id,
          "dealer_info_id": jsonlist.user.company_id,
          "inspection_info_id": Insid,
          "file_type": '3',
          "delete_file": [fileId]
        },
        { headers: { Authorization: jsonlist.token.IdToken } },
      )
        .then(response => {
          reloadDocuments()
          toastOpen('削除に成功しました')
        })
        .catch(error => {
          console.log('検査詳細 資料削除失敗')
          console.log(error)
        })
        .finally(() => {
          setIsLoadingOverlay(false)
        })
    }
  }

  const INS_STATUS_DONE = "1";
  const INS_STATUS_COMPLETE = "2";

  const ins_done = () => {
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    ins_status_update(INS_STATUS_DONE, () => {
      window.location.reload();
    });
    window.open(Url, "_blank");
  }

  const ins_status_update = (status: string, proc: Function) => {
    openLoading()
    console.log(inspection_date)
    axios.post(API_URL.INSPECTION_UPDATE,
      {
        "company_id": jsonlist.user.company_id,
        "dealer_info_id": jsonlist.user.dealer_info_id,
        "construction_id": conid,
        "inspection_info_id": Insid,
        "inspection_info_name": "aaa",
        "blackboard": createdConstructionName,
        "inspection_url": "Chimeの検査用URL",
        "inspection_date": inspection_date,
        "inspection_time": inspection_time,
        "inspection_work_type": inspection_work_type,
        "inspection_kind": inspection_kind,
        "common_number": common_number,
        "inspection_status": status,
        "template": "テンプレート",
        "remarks": remarks,
        "witness": witness,
        "actor": actor
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        setSuccess(true);
        setLoading(false);
        // handleSuOpen();
        console.log(res)
      })
      .catch(error => {
        setSuccess(true);
        setLoading(false);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
        proc()
      })
  }

  return (

    <GenericTemplate title="検査詳細">

      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"このデータを削除しますか？"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleClose}
                >キャンセル</Button>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                {loading
                  ?
                  <Button
                    style={{ width: "100px" }}
                    variant="contained"
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                  :
                  <Button
                    style={{ color: "#fff", backgroundColor: "red", width: "100px" }}
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                }
                {loading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: green[500],
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>

      <Stack spacing={3} margin={2}></Stack>

      <Grid container spacing={0}>
        <Grid item xs={5}>
        </Grid>
        <Grid item xs={5}>
        </Grid>
        <Grid item xs={2}>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button
                style={{ color: "#fff", backgroundColor: "red" }}
                variant="contained"
                onClick={handleClickOpen}
              >
                この検査を削除
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <div className="textBoxInspection">
        {inspection_work_type
          &&

          <Table className="tg2">
            <tbody>
              <tr>
                <th className="tg-0lax">
                  <TextField
                    inputProps={{ readOnly: true }}
                    label="工種※"
                    variant="outlined"
                    className="InsText"
                    value={inspection_work_type}
                  />
                </th>
                <th className="tg-0lax tw">
                  <FormGroup>
                    <Stack spacing={1} marginTop={1}>
                      <Grid container spacing={0} justifyContent="flex-start">
                        <Grid item xs={2}>
                          <Button
                            style={{ color: "#fff", backgroundColor: "#FFA500" }}
                            variant="contained"
                            size="small"
                            disabled={checkListActivation !== '1'}
                            onClick={() => setIsShowCheckLists(isShow => !isShow)}
                          >
                            {isShowCheckLists ? '閉じる' : '確認'}
                          </Button>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="subtitle1" gutterBottom component="div">
                            {checkListActivation === '1' ? '設定済' : '設定なし'}
                          </Typography>
                        </Grid>
                      </Grid>

                      {
                        isShowCheckLists && (
                          <Grid container spacing={0} justifyContent="flex-start">
                            <div className="textBoxCheck_CheckList" style={{ padding: '20px', overflowY: 'scroll', height: "250px" }}>
                              <section>
                                <table>
                                  <tbody>
                                    {checkList?.map((check: any, index: number) => (
                                      <tr key={index}>
                                        <td
                                          style={{ width: "10%", fontSize: "19px" }}
                                        >
                                          {index + 1}
                                        </td>
                                        <td
                                          style={{ width: "70%" }}
                                        >
                                          <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            className="InsText"
                                            multiline={true}
                                            value={check.checklist_name}
                                            size="small"
                                            disabled={true}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </section>
                            </div>
                          </Grid>
                        )
                      }
                    </Stack>
                  </FormGroup>
                </th>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    inputProps={{ readOnly: true }}
                    id="outlined-disabled"
                    label="種別"
                    variant="outlined"
                    className="InsText"
                    value={inspection_kind}
                  />
                </td>
                <td className="tg-0lax" rowSpan={length2}>
                  <Box className="kokuban" sx={{ border: '1px solid grey' }}>

                    <Box component='div'
                      style={{ 'opacity': displayBoardDesign.opacity / 100 }}
                      className={`
                        blackboard
                        color-${displayBoardDesign.color}
                        font-color-${displayBoardDesign.fontColor}`}
                      sx={{ width: '98%' }}
                    >
                      <Box
                        component='div'
                        className={
                          `blackboard-body
                          font-size-${displayBoardDesign.fontSize}
                          ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}
                      >
                        {inspectionDetailBlackBoardInfo.map((value) => {
                          return (
                            <Box
                              key={value.id}
                              component='div'
                              className={`blackboard-row ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                              <Box component='div' className={`${value.left}  ${displayBoardDesign.color === 'white' ? 'black-border' : ''}`}>
                                <p className={
                                  `blackboard-header
                                    alignment-${displayBoardDesign.alignment}
                                    placement-${displayBoardDesign.placement}`}>
                                  {value.header}
                                </p>
                              </Box>
                              <Box component='div' className={value.right}>
                                <p className={
                                  `blackboard-data
                                    alignment-${displayBoardDesign.alignment}
                                    placement-${displayBoardDesign.placement}`}>
                                  {value.data}
                                </p>
                              </Box>
                            </Box>
                          )
                        })}
                      </Box>
                    </Box>
                  </Box>
                </td>
              </tr>
              <tr>

                <td className="tg-0lax">
                  <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
                    <TextField
                      label="実施日"
                      value={inspection_date}
                      inputProps={{ readOnly: true }}
                      sx={{ width: 150 }}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TextField
                      id="time"
                      label="実施時間"
                      type="time"
                      value={inspection_time}
                      inputProps={{ readOnly: true }}
                      sx={{ width: 150 }}
                    />
                  </LocalizationProvider>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    inputProps={{ readOnly: true }}
                    id="outlined-basic"
                    label="土木共通仕様書番号※"
                    variant="outlined"
                    className="InsText"
                    required
                    value={common_number}
                  />
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 300 }}>
                    <InputLabel shrink htmlFor="select-multiple-native">
                      実施者
                    </InputLabel>
                    <Select
                      inputProps={{ readOnly: true }}
                      multiple
                      native
                      value={personName}
                      // @ts-ignore Typings are not considering `native`
                      onChange={handleChangeMultiple}
                      label="Native"
                    >

                      {names.map((name) => (
                        <option key={name} value={name}>
                          {name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">

                  <Stack spacing={3} margin={1}></Stack>
                  {witness.map((field: any, index: any) => (

                    <Grid container spacing={3} key={index}>
                      <Grid item xs={12}>
                        <TextField
                          inputProps={{ readOnly: true }}
                          id="outlined-disabled"
                          label="立会者"
                          variant="outlined"
                          className="InsText2"
                          value={witness[index].name}
                        />
                        <TextField
                          inputProps={{ readOnly: true }}
                          id="outlined-disabled"
                          label="メールアドレス"
                          variant="outlined"
                          className="InsText3"
                          value={witness[index].user_name}
                        />
                        <Button
                          className="btnlink"
                          color="primary"
                          variant="contained"
                          size="large"
                          onClick={() => CopyCheckSubmit(witness[index])}
                        >
                          招待URLコピー
                        </Button>
                      </Grid>
                    </Grid>
                  ))}
                </td>
                <td className="tg-0lax" rowSpan={length}>
                  {fileposts.map((row, index) => (
                    <Paper className={classes.paper} key={index}>
                      <a onClick={() => DLCheckSubmit(row.file_id)} href="#">
                        {row.file_name}
                      </a>
                      {'　'}
                      <IconButton aria-label="delete" size="small" onClick={onClickDeleteDocumentIcon({ fileId: row.file_id, fileName: row.file_name })}>
                        <DeleteIcon fontSize="inherit" sx={{ color: pink[500] }} />
                      </IconButton>
                    </Paper>
                  ))}
                </td>
              </tr>
              <tr>
                <td className="tg-0lax">
                  <TextField
                    inputProps={{ readOnly: true }}
                    id="outlined-basic"
                    label="備考"
                    variant="outlined"
                    className="InsText"
                    multiline={true}
                    rows={2}
                    value={remarks}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        }
      </div>

      <Snackbar
        open={toastOpenFlg}
        autoHideDuration={3000}
        onClose={toastClose}
        message={toastMessage}
        action={action}
      />

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={0} margin={0}>
        <Grid container spacing={0}>
          <Grid item xs={2} className="btnIn">
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              component={Link}
              to={{ pathname: "/Inspectionlist", state: { conid: conid } }}
            >
              戻る
            </Button>
          </Grid>
          <Grid item xs={2} className="btnIn">
            <Button
              style={{ color: "#fff", backgroundColor: "#FFA500" }}
              variant="contained"
              size="large"
              component={Link}
              to={{ pathname: "/Inspectionedit", state: { Insid: Insid, conid: conid, actor: actor, witness: witness } }}
            >
              検査情報編集
            </Button>
          </Grid>
          <Grid item xs={2} className="btnIn">

          </Grid>
          <Grid item xs={2} className="btnIn">

          </Grid>
          <Grid item xs={2} className="btnIn">
          </Grid>
          <Grid item xs={2} className="btnIn">
            {inspection_status === INS_STATUS_COMPLETE ?
              <Button
                // style={{ color: "#fff", backgroundColor: "gray" }}
                variant="contained"
                size="large"
                onClick={ins_done}
                disabled
              >
                検査完了
              </Button>
              :
              <Button
                style={{ color: "#fff", backgroundColor: "#FFA500" }}
                variant="contained"
                size="large"
                onClick={ins_done}
              >
                検査開始
              </Button>
            }
          </Grid>
        </Grid>
      </Stack>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoadingOverlay}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </GenericTemplate>
  );
};
export default InspectionCreat;
